// 组合套餐接口；
import ajax from '@/utils/ajax';

const header = '/web';
// 完成任务
export const reqActivityDoneTask = (data) => ajax(`${header}/v1/card-activity-user/done-task`, data, 'post');

//获取活动信息
export const reqActivityInfo = (teacherCode) => ajax(`${header}/v1/card-activity-user/info?teacherCode=${teacherCode}`);

// 用户抽奖
export const reqActivityLottery = (id) => ajax(`${header}/v1/card-activity-user/lottery?id=${id}`,'','post');


// 用户合成奖品
export const reqActivitySynthesis = (id) => ajax(`${header}/v1/card-activity-user/synthesis?id=${id}`,'','post');


// 调试获取活动任务
export const reqActivityTask = (id,showPort) => ajax(`${header}/v1/card-activity-user/task?id=${id}&showPort=${showPort}`);


// 获取用户活动信息
export const reqActivityUserInfo = (id) => ajax(`${header}/v1/card-activity-user/user-info?id=${id}`);


//校验图片是否包含指定文字
export const reqImageRecognition = (imgUrl) => ajax(`${header}/v1/card-activity-user/check-image?imgUrl=${imgUrl}`);
//填写用户地址
export const reqCardAdress = (data) => ajax(`${header}/v1/card-activity-user`, data, 'post');
//校验激活集卡码
export const reqActivationCode = (data) => ajax(`${header}/v1/tool/security-code/activation-card/${data.code}`, '', 'PUT');
//获取奖品记录
export const reqPrizeRecord = (data) => ajax(`${header}/v1/card-activity-user/prize-record?id=${data.id}`);
//获取活动信息(此处用作读取活动规格)
export const reqCardInfo = (teacherCode) => ajax(`${header}/v1/card-activity-user/info?teacherCode=${teacherCode}`);
//获取用户卡片记录
export const reqCardRecord = (data) => ajax(`${header}/v1/card-activity-user/card-record?id=${data.id}&pageNum=${data.pageNum}&pageSize=${data.pageSize}`);
//获取抽卡记录
export const reqCardDrawRecord = (data) => ajax(`${header}/v1/card-activity-user/card-draw-record?id=${data.id}&pageNum=${data.pageNum}&pageSize=${data.pageSize}`);
//获取奖品记录详情
export const reqPrizeRecordDetail = (data) => ajax(`${header}/v1/card-activity-user/prize-record/${data.id}`);

// 获取最新app版本信息
export const reqAppVersion = () => ajax(`${header}/v1/appVersion/latest`);


// 打卡圈浏览任务
export const reqCircleDoneTask = (data) => ajax(`/applets/v1/user-checkin/callback/obtain-makeup-card`, data, 'post');
